import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth/authentication.service';
import { LoggerService } from '../logger/logger.service';
import { trigger, style, animate, transition } from '@angular/animations';


const log = new LoggerService('LOGIN COMPONENT');


@Component({
  selector: 'login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class LoginDialogComponent implements OnInit{
  
  public loginForm: FormGroup = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  public confirmPasswordForm: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    password: ['', Validators.required],
    passwordConfirm: ['', Validators.required]
  });

  public resetPasswordForm: FormGroup =  this.formBuilder.group({
    email: ['', Validators.required],
    name: ['', Validators.required]
  });

  public isLoading: boolean;
  public errorMessage: string = '';
  public successMessage: string = '';
  public prompt: string = 'login';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private dialogRef: MatDialogRef<LoginDialogComponent>,
  ){}

  ngOnInit() {}
  
  /**
   * @description Llama al servicio de authenticación para completar la sesión del usuario
   */
  public async enterButton() { 
    try {
      //log.debug('Iniciando sesión.');
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage= '';

      if (await this.authenticationService.isLoggedIn()) {
        this.isLoading = false;
        this.router.navigate(['/']);
        this.dialogRef.close();

      } else {
        //log.debug('Inicio de sesión fallido: ');

        const username = this.loginForm.controls['username'].value;
        const password = this.loginForm.controls['password'].value;
        if(!username || !password) {
          this.isLoading = false;
          return;
        };
  
        const authState = await this.authenticationService.logIn(username, password);
        //log.debug('[enterButton] auth response: ', authState);
  
        if (authState === 'loginSuccess'){
          
          this.successMessage = 'Inicio de sesión correcto.';
          setTimeout(() => {
            this.isLoading = false;
            location.replace('/');
            this.dialogRef.close();
          }, 1000);
        }
        
        if (authState === 'newPasswordRequired') {
          this.isLoading =  false;
          this.prompt = 'confirmPassword';
        }
        
        
      }


    } catch (err) {
      this.isLoading = false;
      this.errorMessage = err.message;
      this.loginForm.reset();
      throw err;
    } 
  }


  /**
   * @description Llama al servicio de authenticación para confirmar la contarseña del usuario, esta función solo será utilizada la primera vez que el usuario inicie sesión en epione.
   */
  public async confirmPassword() {
    try {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';
  
      const username = this.loginForm.controls['username'].value;
      const password = this.loginForm.controls['password'].value;
  
      const name = this.confirmPasswordForm.controls['name'].value;
      const newPassword = this.confirmPasswordForm.controls['password'].value;
      const newPasswordConfirm = this.confirmPasswordForm.controls['passwordConfirm'].value;
  
      if(!username || !password || !name || !newPassword || !newPasswordConfirm) {
        this.isLoading =  false;
        this.errorMessage = 'Por favor ingresa todos los datos.';
        return;
      } 
      
      if (newPassword !== newPasswordConfirm) {
        this.isLoading =  false;
        this.errorMessage = 'Las contraseñas ingresadas no coinciden';
        return;
      }
  
      const response = await  this.authenticationService.confirmPassword(username, password, newPassword, name);
      //log.debug('[confirmPassword] Response: ', response);

      if (response === 'confirmPasswordSuccess') {
        this.successMessage = 'Información modificada correctamente.';
        setTimeout(() => {
          this.isLoading = false;
          location.replace('/');
          this.dialogRef.close();
        }, 1000);
      }

      if (response === 'confirmPasswordError') {
        this.isLoading = false;
        this.errorMessage = 'Algo salió mal al confirmar los datos, por favor revisa que la contraseña cumpla los requisitos.';
        this.confirmPasswordForm.reset();
      }

      if (response === 'loginSuccess'){
        this.successMessage = 'Inicio de sesión correcto.';
        setTimeout(() => {
          this.isLoading = false;
          location.replace('/');
          this.dialogRef.close();
        }, 1000);
      }
      
      if (response === 'loginError'){
        this.isLoading = false;
        this.errorMessage = 'Algo salió mal al iniciar sesión.';
        this.confirmPasswordForm.reset();
      }

    } catch(err) {
      this.isLoading = false;
      this.errorMessage = err.message;
      this.confirmPasswordForm.reset();
      throw err;
    }
  }

  /**
   * @description Boton Utilizado para entrar al prompt de reinicio de contraseña.
   */
  public goToReset() {
    //log.debug('[goToReset]');
    this.errorMessage = '';
    this.successMessage = '';
    this.prompt = 'resetPassword';
  }


  public async resetPassword() {
    try {
      
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      const email = this.resetPasswordForm.controls['email'].value;
      const name = this.resetPasswordForm.controls['name'].value;

      if(!name || !email) {
        this.isLoading =  false;
        this.errorMessage = 'Por favor ingresa todos los datos.';
        return;
      } 

      const response = await this.authenticationService.resetPassword(email, name)
      //log.debug('[resetPassword] Response: ', response);

      if (response.state === 'success'){

        this.successMessage = 'Contraseña reiniciada correctamente, revisa tu correo electrónico.';
        setTimeout(() => {
          this.isLoading = false;
          this.returnToLogin();
        }, 2000);

      }

      if (response.state === 'error') {
        this.isLoading = false;
        this.errorMessage = response.message
        return;
      }

    } catch (err) {
      this.isLoading = false;
      this.errorMessage = err.message;
      this.resetPasswordForm.reset();
      throw err;
    }
  }

  public returnToLogin() {
    this.resetPasswordForm.reset();
    this.loginForm.reset();
    this.confirmPasswordForm.reset();
    this.errorMessage = '';
    this.successMessage = '';
    this.prompt = 'login';
  }
}
